/**
 * Copyright 2022 MobiledgeX, Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react";
import Terms from './Terms';
import AcceptablePolicy from "./AcceptablePolicy";
import './style.css'
import { publicConfig } from "../../../services/modules/landing";
import { responseValid } from "../../../services/config";

export default class Policy extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            legalEmail: "",
        }
    }

    render() {
        return (
            <div className="terms">
                <div className="top-header" align="center">
                    <img className='logo' src='/assets/brand/Logo_tm_white.svg' alt="logo" />
                </div>
                <div className="main">
                    {this.props.location.pathname === '/terms-of-use' ? <Terms legalEmail={this.state.legalEmail} /> : <AcceptablePolicy legalEmail={this.state.legalEmail} />}
                </div>
            </div>
        );
    }

    pubCfg = async () => {
        let mc = await publicConfig(this)
        if (responseValid(mc)) {
            let legalEmail = mc.response.data.LegalEmail
            this.setState({ legalEmail })
        }
    }

    componentDidMount() {
        this.pubCfg()
    }
};
